export const ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss"; // 1986-09-04T08:30:25
export const DATE_TIME_SECONDS_FORMAT = 'yyyy-MM-dd HH:mm:ss'; // 1986-09-04 08:30:00
export const DATE_FORMAT = 'yyyy-MM-dd'; // 1986-09-04
export const HUMAN_DATE_TIME_FORMAT = 'do MMM yyyy - HH:mm:ss'; // 4th Sep 1986 - 08:30:25
